<template>
    <form @submit.prevent="onSubmit" class="form-horizontal form-material">
        <div class="card text-white bg-danger" v-if="showFailureMessage">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Validation Errors</h4></div>
            <div class="card-body">
                <p v-if="typeof errors === 'string'" class="card-text">{{errors}}</p>
                <p v-else class="card-text" v-for="(error, key) in errors" :key="key">
                    {{key}}: {{error}}
                </p>
            </div>
        </div>
        <br/>

        <div class="form-group">
            <label class="mb-1">Email address:</label>
            <input v-model="test.email" type="text" class="form-control">
            <div class="text-danger" v-if="$v.test.email.$error">Email is required.</div>
        </div>
        <div class="form-group">
            <label class="mb-1">Sender:</label>
            <input v-model="test.sender" type="text" class="form-control">
            <div class="text-danger" v-if="$v.test.sender.$error">Sender is required.</div>
        </div>
        <div class="mb-3">
            <treeselect placeholder="Select PMTA Relay"
                        v-model="test.pmtaRelay"
                        :multiple="false"
                        :options="pmtaRelayList"
                        :load-options="loadPmtaRelayList"
                        value-format="object"
                        :disable-branch-nodes="true"
                        :normalizer="normalizer"
            />
            <div class="text-danger" v-if="$v.test.pmtaRelay.$error">Message is required.</div>
        </div>
        <div class="mb-3">
            <treeselect placeholder="Select Message"
                        v-model="test.message"
                        :multiple="false"
                        :options="messageList"
                        :load-options="loadMessageList"
                        value-format="object"
            />
            <div class="text-danger" v-if="$v.test.message.$error">Message is required.</div>
        </div>
        <div class="mb-5">
            <treeselect placeholder="Select Offer"
                        v-model="test.offer"
                        :multiple="false"
                        :options="offerList"
                        :load-options="loadOfferList"
                        value-format="object"
            />
            <div class="text-danger" v-if="$v.test.offer.$error">Offer is required.</div>
        </div>
        <div class="form-group text-center p-b-20">
            <div class="col-xs-12">
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" v-show="!submitting">
                    Save
                </button>
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" disabled
                        v-show="submitting">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Submitting...
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import {required} from 'vuelidate/lib/validators';
    import EmailTestService from '../../services/EmailTestService';
    import PmtaRelayService from '../../services/PmtaRelayService';
    import PmtaRelayGroupService from '../../services/PmtaRelayGroupService';
    import MessageService from '../../services/MessageService';
    import OfferService from '../../services/OfferService';
    import Treeselect from '@riophae/vue-treeselect';
    import UserService from '../../services/UserService';

    export default {
        name: 'PmtaEmailTestForm',
        props: ['cloneId'],
        components: {Treeselect},
        data() {
            return {
                test: {
                    email: null,
                    sender: null,
                    message: null,
                    pmtaRelay: null,
                    offer: null,
                },
                errors: {},
                showFailureMessage: false,
                pmtaRelayList: null,
                messageList: null,
                offerList: null,
                submitting: false,
                normalizer(node) {
                    return {
                        id: node.id,
                        label: node.label,
                        children: node.children
                    }
                }
            }
        },
        mounted() {
            if (this.$route.params.cloneId) {
                this.$emit('hidePreloader', true);
                EmailTestService.getPmtaEmailTest(this.$route.params.cloneId).then(response => {
                    this.test = response.data;
                    this.$emit('hidePreloader', false)
                });
            }
        },
        validations: {
            test: {
                email: {required},
                sender: {required},
                message: {required},
                pmtaRelay: {required},
                offer: {required},
            }
        },
        methods: {
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) return;
                this.submitting = true;
                EmailTestService.createPmtaEmailTest(JSON.stringify(this.test)).then(response => {
                    if ([200, 201].includes(response.status)) {
                        this.$router.push({name: 'pmtaEmailTests'});
                    }
                    this.submitting = false;
                    this.errors = response.data.error !== undefined ? response.data.error : 'Some error occurred.';
                    this.showFailureMessage = true;
                });
            },
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            },
            loadMessageList({callback}) {
                MessageService.getMessageSelect().then(response => {
                    this.messageList = response.data['hydra:member'].map(msg => {
                        return {id: msg.id, label: msg.name}
                    });
                    callback();
                });
            },
            loadOfferList({callback}) {
                OfferService.getOfferSelect().then(response => {
                    this.offerList = response.data['hydra:member'].map(offer => {
                        return {id: offer.id, label: offer.name}
                    });
                    callback();
                });
            },
            loadPmtaRelayList({callback}) {
                this.pmtaRelayList = [];
                PmtaRelayGroupService.getGroupSelect().then(response => {
                    response.data['hydra:member'].map(group => {
                        let relaysByGroup = [];
                        PmtaRelayService.getRelaysByGroup(group.id).then(response => {
                            relaysByGroup = response.data['hydra:member'].map(relay => {
                                return {id: relay.id, label: relay.smtpHost}
                            });
                            this.pmtaRelayList.push({id: '_' + group.id, label: group.name, children: relaysByGroup});
                        });
                    });
                    callback();
                });
            }
        }
    }
</script>

<style scoped>

</style>
